import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { EmailLabel, EmailValue } from 'server-model';

@Component({
  selector: 'app-single-email-input',
  templateUrl: './single-email-input.component.html',
  styleUrl: './single-email-input.component.scss'
})
export class SingleEmailInputComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: EmailValue[] = [];
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() showLabel: boolean = true;
  @Output() valueChange = new EventEmitter<EmailValue[]>();
  @Output() isFieldInvalid = new EventEmitter<boolean>();

  updateValue(value: string) {
    const isValidEmail = this.isValidEmail(value);
    if (!isValidEmail && value) {
      this.error = true;
      this.errorText = 'Please enter a valid email address.';
      this.isFieldInvalid.emit(true);
    } else {
      this.error = false;
      this.errorText = 'This field is required.';
      let emailValue: EmailValue[] = value ? [{ label: EmailLabel.WORK, value: value, primary: true }] : [];
      this.value = emailValue;
      this.valueChange.emit(this.value);
      this.isFieldInvalid.emit(false);
    }
  }

  isValidEmail(value: string) {
    // This regex checks for an optional leading sign, digits, optional decimal, and optional digits after the decimal.
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(value);
  }
}
